import { createElementVNode as _createElementVNode, vModelText as _vModelText, withDirectives as _withDirectives, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"
import _imports_0 from '../../assets/logo/BIMO_logo.svg'


const _hoisted_1 = { class: "container-fluid" }
const _hoisted_2 = { class: "row" }
const _hoisted_3 = /*#__PURE__*/_createElementVNode("div", { class: "col-sm-12" }, [
  /*#__PURE__*/_createElementVNode("img", { src: _imports_0 })
], -1)
const _hoisted_4 = { class: "offset-sm-4 col-sm-4" }
const _hoisted_5 = { class: "card text-center" }
const _hoisted_6 = { class: "card-body" }
const _hoisted_7 = { class: "input-group mb-3" }
const _hoisted_8 = { class: "input-group mb-3" }
const _hoisted_9 = /*#__PURE__*/_createElementVNode("button", {
  class: "btn btn-dark",
  type: "submit"
}, "Login", -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _hoisted_3,
      _createElementVNode("div", _hoisted_4, [
        _createElementVNode("div", _hoisted_5, [
          _createElementVNode("div", _hoisted_6, [
            _createElementVNode("form", {
              class: "login-form",
              onSubmit: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.submit && _ctx.submit(...args)))
            }, [
              _createElementVNode("div", _hoisted_7, [
                _withDirectives(_createElementVNode("input", {
                  type: "text",
                  class: "form-control",
                  "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.formData.email) = $event)),
                  placeholder: "Email address"
                }, null, 512), [
                  [_vModelText, _ctx.formData.email]
                ])
              ]),
              _createElementVNode("div", _hoisted_8, [
                _withDirectives(_createElementVNode("input", {
                  type: "password",
                  class: "form-control",
                  "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.formData.password) = $event)),
                  placeholder: "Your password"
                }, null, 512), [
                  [_vModelText, _ctx.formData.password]
                ])
              ]),
              _hoisted_9
            ], 32)
          ])
        ])
      ])
    ])
  ]))
}